import {
    findBullionLobbyGamesForMatchId,
    bullionLobbyUserHasActivePlay,
} from "./bullionMatchLandingLobby";
import type { BullionLobbyUserActiveGame } from "./types";
import type { RawMatch } from "./bullionRawMatch";
import { isRawMatchFinishedForBullionLobby } from "./bullionRawMatch";

/**
 * Lobby inclusion for a user’s plays: unsettled only once my-games has loaded.
 * Settled HISTORY rows alone must not keep a finished fixture on the lobby list.
 */
export function bullionLobbyUserHasLobbyRelevantPlay(
    matchId: string,
    userActiveMatchIds: Set<string>,
    bullionActivePlaysLoaded: boolean,
    activeByMatch?: Record<string, BullionLobbyUserActiveGame[]>
): boolean {
    if (!bullionActivePlaysLoaded) {
        return bullionLobbyUserHasActivePlay(matchId, userActiveMatchIds);
    }
    return bullionUserHasUnsettledPlayOnMatch(matchId, activeByMatch);
}

export function bullionUserHasUnsettledPlayOnMatch(
    matchId: string,
    activeByMatch: Record<string, BullionLobbyUserActiveGame[]> | undefined
): boolean {
    if (!activeByMatch) return false;
    const games = findBullionLobbyGamesForMatchId(matchId, activeByMatch);
    if (games.length === 0) return false;
    return games.some((g) => {
        const s = String(g.gameStatus ?? "").toLowerCase();
        return s !== "settled" && s !== "cancelled";
    });
}

/** Drop terminal fixtures from lobby/session lists unless the user still has an open play there. */
export function pruneStaleBullionLobbyRows(
    rows: unknown[],
    activeByMatch?: Record<string, BullionLobbyUserActiveGame[]>
): unknown[] {
    return rows.filter((row) => {
        const match = row as RawMatch;
        const id = String(match?.id ?? "").trim();
        if (!id) return false;
        if (!isRawMatchFinishedForBullionLobby(match)) return true;
        return bullionUserHasUnsettledPlayOnMatch(id, activeByMatch);
    });
}
